import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-texas-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./texas-state-form.component.html",
  styleUrl: "./texas-state-form.component.scss",
})
export class TexasStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
